"use client";

import React from "react";
import { CircleCheck, Info } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { Button } from "@/components/ui/button";
const hotspots = [{
  id: "fan",
  top: "15%",
  left: "45%",
  title: "Aerodynamický design ventilátoru",
  description: "Snižuje provozní hluk a zároveň maximalizuje účinnost proudění vzduchu."
}, {
  id: "exchanger",
  top: "45%",
  left: "25%",
  title: "Antikorozní výměník tepla",
  description: "Ošetřené žebra zajišťují dlouhodobou odolnost v náročných podmínkách."
}, {
  id: "compressor",
  top: "75%",
  left: "60%",
  title: "Kompressor řízený invertorem",
  description: "Dvojitý rotační kompresor pro přesné přizpůsobení zatížení a úsporu energie."
}, {
  id: "control",
  top: "35%",
  left: "75%",
  title: "Inteligentní řídicí deska",
  description: "Pokročilý mikroprocesor pro diagnostiku v reálném čase a integraci s NEXO CORE."
}];
const benefits = ["Přesná regulace teploty napříč více nezávislými zónami", "Až o 40 % vyšší energetická účinnost oproti tradičním HVAC systémům", "Tichý provoz vhodný pro komerční i rezidenční prostory", "Bezproblémová integrace s naší proprietární platformou NEXO CORE"];
export default function AdvancedHvacTechnology() {
  return <section id="advanced-hvac-technology" className="dark bg-background text-foreground py-24 overflow-hidden">
      <div className="max-w-screen-xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          
          {}
          <div className="lg:col-span-7 relative w-full aspect-square md:aspect-[4/3] lg:aspect-auto lg:h-[600px] rounded-2xl overflow-hidden bg-muted/20 border border-border/50 shadow-2xl">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1582043/img/modern_vrf_hvac_system.png" alt="Moderní VRF HVAC systém" className="w-full h-full object-cover object-center opacity-90 mix-blend-luminosity hover:mix-blend-normal transition-all duration-700" />
            
            {}
            <div className="absolute inset-0 bg-gradient-to-t from-background/80 via-transparent to-transparent pointer-events-none" />

            {}
            <TooltipProvider delayDuration={100}>
              {hotspots.map((hotspot, i) => <div key={hotspot.id} data-index={i} className="absolute z-10 transform -translate-x-1/2 -translate-y-1/2" style={{
              top: hotspot.top,
              left: hotspot.left
            }}>
                  <Tooltip>
                    <TooltipTrigger asChild>
                      <Button variant="ghost" size="icon" className="relative h-8 w-8 group outline-none" aria-label={`View details for ${hotspot.title}`}>
                        <span className="absolute inline-flex h-full w-full rounded-full bg-secondary/60 opacity-75 animate-ping group-hover:animate-none group-hover:bg-secondary/80 transition-colors duration-300" />
                        <span className="relative inline-flex rounded-full h-4 w-4 bg-secondary border-2 border-background shadow-lg group-hover:scale-125 transition-transform duration-300" />
                      </Button>
                    </TooltipTrigger>
                    <TooltipContent side="top" className="max-w-[250px] p-4 bg-card border border-border shadow-xl">
                      <div className="space-y-1.5">
                        <h4 className="font-semibold text-sm text-foreground flex items-center gap-2">
                          <Info className="w-4 h-4 text-primary" />
                          {hotspot.title}
                        </h4>
                        <p className="text-xs text-muted-foreground leading-relaxed">
                          {hotspot.description}
                        </p>
                      </div>
                    </TooltipContent>
                  </Tooltip>
                </div>)}
            </TooltipProvider>
          </div>

          {}
          <div className="lg:col-span-5 flex flex-col space-y-8">
            <div className="space-y-4">
              <div className="inline-flex items-center rounded-full border border-primary/30 bg-primary/10 px-3 py-1 text-sm font-medium text-primary">
                Inženýrská dokonalost
              </div>
              <h2 className="text-4xl md:text-5xl font-extrabold tracking-tight bg-gradient-to-r from-primary via-primary/80 to-transparent bg-clip-text text-transparent pb-2">
                VRF systémy nové generace
              </h2>
              <p className="text-lg text-muted-foreground leading-relaxed">
                Zažijte bezkonkurenční řízení klimatu s naší špičkovou technologií Variable Refrigerant Flow. Navrženo pro maximální účinnost a spolehlivost v nejnáročnějších podmínkách.
              </p>
            </div>

            <ul className="space-y-4">
              {benefits.map((benefit, i) => <li key={i} data-index={i} className="flex items-start gap-3">
                  <CircleCheck className="w-6 h-6 text-secondary shrink-0 mt-0.5" />
                  <span className="text-foreground/90 font-medium leading-relaxed">
                    {benefit}
                  </span>
                </li>)}
            </ul>

            <div className="pt-4">
              <Button size="lg" className="w-full sm:w-auto text-base h-12 px-8">
                Prozkoumat technické specifikace
              </Button>
            </div>
          </div>

        </div>
      </div>
    </section>;
}